import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/login.jpg'


const _hoisted_1 = { class: "m-auto m-1230" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "mw-480 ms-lg-auto" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "form-floating mb-4" }
const _hoisted_9 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_10 = { class: "form-floating mb-4 position-relative" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "material-symbols-outlined" }
const _hoisted_13 = { class: "form-group mb-4" }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "form-floating mb-4" }
const _hoisted_16 = { class: "form-floating mb-4" }
const _hoisted_17 = { class: "form-group mb-4" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}
const _hoisted_20 = { class: "form-group mb-4" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_23 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center py-1"
}
const _hoisted_24 = { class: "material-symbols-outlined text-white fs-20 me-2" }
const _hoisted_25 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-lg-6 d-none d-lg-block" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "rounded-3",
          alt: "login"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "fs-28 mb-2" }, "Bentornato!", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("p", { class: "fw-medium fs-16 mb-4" }, " Accedi per continuare ", -1)),
          _createElementVNode("form", {
            onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.showVerificationStep ? _ctx.handleVerification() : _ctx.handleLogin()), ["prevent"])),
            class: "auth-form"
          }, [
            (_ctx.apiError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.apiError), 1))
              : _createCommentVNode("", true),
            (_ctx.verificationSent && _ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Ti abbiamo inviato un codice di verifica all'indirizzo " + _toDisplayString(_ctx.email) + ". Inseriscilo qui sotto per completare l'accesso. ", 1))
              : _createCommentVNode("", true),
            (!_ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: _normalizeClass(["form-control h-55", { 'is-invalid': _ctx.emailError }]),
                      id: "loginEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validateEmail && _ctx.validateEmail(...args))),
                      required: ""
                    }, null, 34), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("label", { for: "loginEmail" }, "Indirizzo Email", -1)),
                    (_ctx.emailError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.emailError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: _ctx.passwordFieldType,
                      class: "form-control h-55",
                      id: "loginPassword",
                      placeholder: "Inserisci la password",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                      required: ""
                    }, null, 8, _hoisted_11), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", { for: "loginPassword" }, "Password", -1)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn border-0 position-absolute top-50 end-0 translate-middle-y d-flex align-items-center justify-content-center",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.togglePasswordVisibility && _ctx.togglePasswordVisibility(...args)))
                    }, [
                      _createElementVNode("i", _hoisted_12, _toDisplayString(_ctx.isPasswordVisible ? 'visibility_off' : 'visibility'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$emit('switch-to-forgot')), ["prevent"])),
                      class: "text-decoration-none text-primary fw-semibold"
                    }, " Password dimenticata? ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showVerificationStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      class: "form-control h-55",
                      id: "verifyEmail",
                      placeholder: "esempio@email.com",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event)),
                      disabled: ""
                    }, null, 512), [
                      [_vModelText, _ctx.email]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("label", { for: "verifyEmail" }, "Indirizzo Email", -1))
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control h-55",
                      id: "verificationCode",
                      placeholder: "Inserisci il codice di verifica",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.verificationCode) = $event)),
                      maxlength: "6",
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.verificationCode]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("label", { for: "verificationCode" }, "Codice di Verifica", -1))
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-link p-0 text-decoration-none",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args))),
                      disabled: _ctx.resendLoading
                    }, [
                      (_ctx.resendLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      _cache[16] || (_cache[16] = _createTextVNode(" Non hai ricevuto il codice? Invia di nuovo ", -1))
                    ], 8, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary fw-medium py-2 px-3 w-100",
                disabled: (!_ctx.showVerificationStep && (!_ctx.isFormValid || _ctx.isLoading)) || (_ctx.showVerificationStep && _ctx.isLoading)
              }, [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                    ]))]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createElementVNode("i", _hoisted_24, _toDisplayString(_ctx.showVerificationStep ? 'verified_user' : 'login'), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.showVerificationStep ? 'Verifica Email' : 'Accedi'), 1)
                    ]))
              ], 8, _hoisted_21)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, [
                _cache[18] || (_cache[18] = _createTextVNode(" Non hai un account? ", -1)),
                _createElementVNode("a", {
                  href: "#",
                  class: "fw-medium text-primary text-decoration-none",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.$emit('switch-to-register')), ["prevent"]))
                }, " Registrati ")
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}